"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _options = require("@/utils/options.js");
var _competitionProductConfig = require("@/api/priceSetting/priceMonitoring/competitionProductConfig.js");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'CompetitionProductInfoForm',
  data: function data() {
    return {
      dialogVisible: false,
      // 是否显示弹框
      dialogTitle: '',
      // 弹框标题
      formType: '',
      // 表单类型：create - 新增 update - 修改
      formLoading: false,
      //  表单加载状态
      platformIdsOptions: _options.platformIdsOptions,
      // 竞品平台选项
      formData: {
        // 表单数据
        id: null,
        productId: null,
        // 商品ID
        skuId: null,
        // 商品skuid
        platform: null,
        // 竞品平台
        productName: null,
        // 竞品商品名称
        specName: null,
        // 竞品商品规格
        // productCode: null, // 竞品商品编码
        // skuCode: null, // 竞品SKU编码
        url: null // 竞品URL地址
      },
      rules: {
        // 表单验证规则
        platform: [{
          required: true,
          message: '请选择竞品平台',
          trigger: ['change', 'blur']
        }],
        productName: [{
          required: true,
          message: '请输入竞品商品名称',
          trigger: 'blur'
        }],
        specName: [{
          required: true,
          message: '请输入竞品商品规格',
          trigger: 'blur'
        }],
        url: [{
          required: true,
          message: '请输入竞品URL地址',
          trigger: 'blur'
        }, {
          validator: this.validateUrl,
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    // 验证URL格式
    validateUrl: function validateUrl(rule, value, callback) {
      if (!value) {
        callback(new Error('请输入竞品URL地址'));
        return;
      }

      // 尝试解码URL，处理可能存在的URL编码字符
      var decodedValue;
      try {
        decodedValue = decodeURIComponent(value);
      } catch (e) {
        callback(new Error('URL格式不正确，无法解析'));
        return;
      }

      // 获取当前竞品平台 (1为淘宝，2为京东)
      var platform = this.formData.platform;

      // 如果平台未定义或未知
      if (!platform) {
        callback(new Error('请选择正确的竞品平台'));
        return;
      }

      // 如果是淘宝平台
      if (platform === 1) {
        // 淘宝URL验证: 需要包含id参数，skuId参数可选但如果有则必须为数字
        var validTaoBaoPattern = /^(https:\/\/(detail\.tmall\.com\/item\.htm|item\.taobao\.com\/item\.htm|item\.taobao\.com\/item\.htm)\?)/;
        if (validTaoBaoPattern.test(decodedValue)) {
          // 直接获取id参数值并验证是否为数字
          var idMatch = decodedValue.match(/[?&]id[=](\d+)(?=&|$)/i);
          if (!idMatch) {
            callback(new Error('淘宝URL中必须包含id参数且为数字'));
            return;
          }

          // 检查是否有skuId参数，如果有则验证是否为数字
          var fullSkuIdMatch = decodedValue.match(/[?&]skuId[=]([^&]+)/i); // 匹配skuId=后面的所有字符直到&或结尾
          if (fullSkuIdMatch) {
            var skuIdValue = fullSkuIdMatch[1]; // 获取skuId的值
            if (!/^\d+$/.test(skuIdValue)) {
              callback(new Error('淘宝URL中的skuId参数必须为数字'));
              return;
            }
          }
          callback();
          return;
        }

        // 如果不是有效的淘宝URL
        callback(new Error('请输入正确的淘宝商品地址，格式如：https://detail.tmall.com/item.htm?id=1234567890&skuId=1234567890'));
        return;
      }

      // 如果是京东平台
      if (platform === 2) {
        // 京东URL验证: https://item.jd.com/{数字ID}.html
        // 允许有查询参数，但必须严格匹配，不允许有任何片段标识符等
        var jdPattern = /^https:\/\/item\.jd\.com\/(\d+)\.html(?:\?.*)?$/;
        if (jdPattern.test(decodedValue)) {
          var skuId = jdPattern.exec(decodedValue)[1];
          if (skuId && /^\d+$/.test(skuId)) {
            callback();
            return;
          }
        }

        // 如果不是有效的京东URL
        callback(new Error('请输入正确的京东商品地址，格式如：https://item.jd.com/1234567890.html'));
        return;
      }

      // 如果平台值不在预期范围内
      callback(new Error('请选择正确的竞品平台'));
    },
    /**
     * 打开弹框
     * @param {String} type 弹框类型 create - 新增 update - 修改
     * @param {String} platform 竞品平台 TB - 淘宝 JD - 京东
     * @param {Number} productId 商品ID
     * @param {Number} skuId 商品skuid
     * @param {Number} id 竞品ID
    */
    open: function open(type, platform, productId, skuId, row) {
      this.dialogVisible = true;
      this.dialogTitle = "".concat(type === 'create' ? '添加' : '修改', "\u7ADE\u54C1\u5E73\u53F0\u5546\u54C1\u4FE1\u606F");
      this.formType = type;
      this.formData.platform = platform === 'TB' ? 1 : 2;
      if (row !== null && row !== void 0 && row.manualId) {
        this.formData = {
          id: row.manualId,
          platform: row.platform,
          productName: row.productName || null,
          specName: row.specName || null,
          // productCode: row.productCode || null,
          // skuCode: row.skuCode || null,
          url: row.url
        };
      } else {
        this.formData.productId = productId;
        this.formData.skuId = skuId;
      }
    },
    // 提交表单
    submitForm: function submitForm() {
      var _this = this;
      // 校验表单
      this.$refs.formRef.validate(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(valid) {
          var processedFormData, hasSkuId, _t;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.p = _context.n) {
              case 0:
                if (valid) {
                  _context.n = 1;
                  break;
                }
                return _context.a(2);
              case 1:
                // 处理URL：尝试解码，如果解码失败则使用原始URL
                processedFormData = _objectSpread({}, _this.formData);
                try {
                  processedFormData.url = decodeURIComponent(_this.formData.url);
                } catch (e) {
                  // 如果解码失败，继续使用原始URL
                  console.warn('URL解码失败，使用原始URL:', e);
                }

                // 特殊处理：如果是淘宝平台且URL中没有skuId，提示用户确认
                if (!(processedFormData.platform === 1)) {
                  _context.n = 5;
                  break;
                }
                hasSkuId = /[?&]skuId[=]\d+(?=&|$)/i.test(processedFormData.url);
                if (hasSkuId) {
                  _context.n = 5;
                  break;
                }
                _context.p = 2;
                _context.n = 3;
                return _this.$confirm('您输入的淘宝URL中没有包含skuId参数，这可能会影响价格监测的准确性。确定继续提交吗？', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                });
              case 3:
                _context.n = 5;
                break;
              case 4:
                _context.p = 4;
                _t = _context.v;
                return _context.a(2);
              case 5:
                // 提交请求
                _this.formLoading = true;
                if (!(_this.formType === 'create')) {
                  _context.n = 10;
                  break;
                }
                _context.p = 6;
                _context.n = 7;
                return (0, _competitionProductConfig.addCompetitorApi)(processedFormData);
              case 7:
                _this.$message.success('添加成功！');
                _this.dialogVisible = false;
                _this.$emit('success');
              case 8:
                _context.p = 8;
                _this.formLoading = false;
                return _context.f(8);
              case 9:
                _context.n = 13;
                break;
              case 10:
                _context.p = 10;
                _context.n = 11;
                return (0, _competitionProductConfig.editCompetitorApi)(processedFormData);
              case 11:
                _this.$message.success('修改成功！');
                _this.dialogVisible = false;
                _this.$emit('success');
              case 12:
                _context.p = 12;
                _this.formLoading = false;
                return _context.f(12);
              case 13:
                return _context.a(2);
            }
          }, _callee, null, [[10,, 12, 13], [6,, 8, 9], [2, 4]]);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    // 重置表单
    resetForm: function resetForm() {
      this.formData = {
        id: null,
        productId: null,
        // 商品ID
        skuId: null,
        // 商品skuid
        platform: null,
        // 竞品平台
        productName: null,
        // 竞品商品名称
        specName: null,
        // 竞品商品规格
        // productCode: null, // 竞品商品编码
        // skuCode: null, // 竞品SKU编码
        url: null // 竞品URL地址
      };
      this.$refs.formRef.resetFields();
      this.formLoading = false;
    }
  }
};